const url = "/api/v1/bookings/bookings";
import { getToken } from "./user-service";
import axios from "axios";
import { add } from "date-fns";
import moment from 'moment';

const takeOutValues = (dict) => {
  return dict.map((e) => e.value);
};

const takeOutDoc = (dict) => {
  return dict.map((e) => e.doc);
};

// used for getting all counts for the entire month for the calendar
export const getBookingsForecastTable = async (params) => {
  const token = await getToken();
  const url =
    "/api/v1/bookings/bookings/" +
    params.iata +
    "?start=" +
    params.date +
    "&end=" +
    params.date +
    "&limit=1000&skip=0" +
    `&type=${params.type}` +
    `&source=${params.source || "none"}` +
    `&forecast=${params.forecast || ""}` +
    `&reduce=${params.reduce}` +
    (params.breakdownTable ? `&breakdownTable=${params.breakdownTable}` : "");

  return new Promise(async (resolve, reject) => {
    try {
      const json = await axios.get(url, {
        headers: { "Firebase-UID": token },
      });

      if (json.status >= 400 && json.status < 600) {
        throw new Error("Bad booking details");
      }

      console.log("booking request table ", json.data);
      resolve(json.data);
    } catch (e) {
      console.log(e);
      reject(new Error("error getting bookings"));
    }
  });
};

export const getUserBookingList = async (uuid) => {
  //console.log('getting booking list', uuid)
  const token = await getToken();
  // need to pass in correct months
  const new_url = "/api/v1/bookings/bookings/getUserBookings/" + uuid;
  //console.log('getting user bookings', new_url)
  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(new_url, {
        method: "GET",
        headers: { "Firebase-UID": token },
      });
      let json = await response.json();
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad booking details");
      }

      //console.log('response from getting user bookings', json)
      resolve(json);
    } catch (e) {
      reject(new Error("error getting bookings"));
    }
  });
};

export const getBookings = async (params) => {
  const token = await getToken();
  // need to pass in correct months
  const new_url =
    "/api/v1/bookings/bookings/" +
    params.iata +
    "?start=2022-07-01&end=2022-07-31&limit=100000&skip=0";

  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(new_url, {
        method: "GET",
        headers: { "Firebase-UID": token },
      });
      let json = await response.json();
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad booking details");
      }

      resolve(json);
    } catch (e) {
      reject(new Error("error getting bookings"));
    }
  });
};

// used for counting departures and arrivals total
export const getListCount = async (params) => {
  const token = await getToken();

  const url =
    "/api/v1/bookings/bookings/" +
    params.iata +
    "?start=" +
    params.start +
    "&end=" +
    params.end +
    "&limit=100000&skip=0&count_by=flightConfirmationDetails.destination&counts_only=true";

  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: { "Firebase-UID": token },
      });

      let json = await response.json();

      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad list details");
      }

      resolve(json.counts);
    } catch (e) {
      reject(new Error("error getting list count"));
    }
  });
};

// used for internal count
export const getArrivalsOrDeparturesCount = async (params, signal) => {
  const token = await getToken();

  const url =
    "/api/v1/bookings/bookings/" +
    params.iata +
    "?start=" +
    params.start +
    "&end=" +
    params.end +
    "&limit=100000&skip=0&count_by=flightConfirmationDetails.destination&listCount=" +
    params.start +
    "&type=" +
    params.type +
    "&name=" +
    params.search +
    "&carrierCode=" +
    (params.carrierCode ? params.carrierCode : "") +
    "&source=" +
    params.source;
  "&forecast=" + params.forecast;

  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.get(url, {
        signal: signal.signal,
        headers: { "Firebase-UID": token },
      });

      let json = response.data;

      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad list details");
      }

      resolve(json);
    } catch (e) {
      reject(new Error("error getting list count"));
    }
  });
};

export const getDeparturesWithSearch = async (params, signal) => {
  const token = await getToken();

  // TODO needs to be added back in
  const new_url =
    "api/v1/bookings/bookings/mangoRequest/" +
    params.iata +
    "?start=" +
    params.start +
    "&end=" +
    params.end +
    "&limit=" +
    params.limit +
    "&skip=" +
    params.skip +
    "&type=outbound" +
    "&name=" +
    params.search +
    "&carrierCode=" +
    (params.carrierCode ? params.carrierCode : "") +
    `${params.csv ? "&csv=" + params.csv : ""}` +
    `${params.source ? "&source=" + params.source : ""}` +
    `${params.forecast ? "&forecast=" + params.forecast : ""}`;

  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.get(new_url, {
        signal: signal.signal,
        headers: { "Firebase-UID": token },
      });

      if (params.csv || params.forecast) {
        resolve(response.data);
      }

      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad booking details");
      }

      let bookings = takeOutDoc(await response.data);

      resolve(bookings);
    } catch (e) {
      reject(new Error("error getting bookings"));
    }
  });
};

export const getDepartures = async (params, signal) => {
  const token = await getToken();

  // TODO needs to be added back in
  const new_url =
    "api/v1/bookings/bookings/" +
    params.iata +
    "?start=" +
    params.start +
    "&end=" +
    params.end +
    "&limit=" +
    params.limit +
    "&skip=" +
    params.skip +
    "&type=outbound" +
    "&name=" +
    params.search +
    "&carrierCode=" +
    (params.carrierCode ? params.carrierCode : "") +
    `${params.csv ? "&csv=" + params.csv : ""}` +
    `${params.source ? "&source=" + params.source : ""}` +
    `${params.forecast ? "&forecast=" + params.forecast : ""}`;

  // if(params.forecast) { console.log('getting departures: ', new_url); }

  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.get(new_url, {
        signal: signal.signal,
        headers: { "Firebase-UID": token },
      });

      if (params.csv || params.forecast) {
        resolve(response.data);
      }

      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad booking details");
      }

      let bookings = takeOutDoc(await response.data);
      resolve(bookings);

    } catch (e) {
      reject(new Error("error getting bookings"));
    }
  });
};

export const getDeparturesForecastRange = async (params, signal) => {
  const token = await getToken();

  const startDate = moment(new Date(params.start)).format().split("T")[0]
  const endDate = moment(new Date(params.end)).format().split("T")[0]

  // TODO needs to be added back in
  const new_url =
    "api/v1/bookings/bookings/" +
    params.iata +
    "?start=" +
    startDate +
    "&end=" +
    endDate +
    "&limit=" +
    params.limit +
    "&skip=" +
    params.skip +
    "&type=outbound" +
    "&name=" +
    params.search +
    "&carrierCode=" +
    (params.carrierCode ? params.carrierCode : "") +
    `${params.csv ? "&csv=" + params.csv : ""}` +
    `${params.source ? "&source=" + params.source : ""}` +
    `${params.forecast ? "&forecast=" + params.forecast : ""}`;

  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.get(new_url, {
        signal: signal.signal,
        headers: { "Firebase-UID": token },
      });
      let result = {
        bookings: response.data,
        startDate: startDate,
        endDate: endDate,
      }
      if (params.csv || params.forecast) {
        resolve(result);
      }

      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad booking details");
      }

      let bookings = takeOutDoc(await response.data);
      resolve({ bookings: bookings, startDate: startDate, endDate: endDate });

    } catch (e) {
      reject(new Error("error getting bookings"));
    }
  });
};

export const getPRMConnectBookings = async (params, signal) => {
  const token = await getToken();

  const new_url =
    "api/v1/bookings/bookings/" +
    params.iata +
    "?start=" +
    params.start +
    "&end=" +
    params.end +
    "&limit=" +
    params.limit +
    "&skip=" +
    params.skip +
    "&type=all" +
    "&name=" +
    params.search +
    `${params.carrierCode ? "&carrierCode=" + params.carrierCode : "&carrierCode="}` +
    "&csv=true" +
    "&source=C" +
    `${params.forecast ? "&forecast=" + params.forecast : ""}`;

  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.get(new_url, {
        signal: signal.signal,
        headers: { "Firebase-UID": token },
      });

      if (params.csv || params.forecast) {
        resolve(response.data);
      }

      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad booking details");
      }

      let bookings = takeOutDoc(await response.data);

      resolve(bookings);
    } catch (e) {
      reject(new Error("error getting bookings"));
    }
  });
};

export const getArrivalsWithSearch = async (params, signal) => {
  const token = await getToken();

  const new_url =
    "/api/v1/bookings/bookings/mangoRequest/" +
    params.iata +
    "?start=" +
    params.start +
    "&end=" +
    params.end +
    "&limit=" +
    params.limit +
    "&skip=" +
    params.skip +
    "&type=inbound" +
    "&name=" +
    params.search +
    "&carrierCode=" +
    (params.carrierCode != undefined ? params.carrierCode : "") +
    `${params.csv ? '&csv=' + params.csv : ''}` +
    `${params.source ? '&source=' + params.source : ''}` +
    `${params.forecast ? '&forecast=' + params.forecast : ''}`
    ;

  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.get(new_url, {
        signal: signal.signal,
        headers: { "Firebase-UID": token },
      });

      if (params.csv || params.forecast) {
        resolve(response.data)
      }

      let json = response.data;
      json = takeOutDoc(response.data);

      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad booking details");
      }

      resolve(json);
    } catch (e) {
      reject(new Error("error getting bookings"));
    }
  });
};

export const getArrivals = async (params, signal) => {
  const token = await getToken();

  const new_url =
    "/api/v1/bookings/bookings/" +
    params.iata +
    "?start=" +
    params.start +
    "&end=" +
    params.end +
    "&limit=" +
    params.limit +
    "&skip=" +
    params.skip +
    "&type=inbound" +
    "&name=" +
    params.search +
    "&carrierCode=" +
    (params.carrierCode != undefined ? params.carrierCode : "") +
    `${params.csv ? '&csv=' + params.csv : ''}` +
    `${params.source ? '&source=' + params.source : ''}` +
    `${params.forecast ? '&forecast=' + params.forecast : ''}`
    ;

  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.get(new_url, {
        signal: signal.signal,
        headers: { "Firebase-UID": token },
      });

      if (params.csv || params.forecast) {
        resolve(response.data)
      }

      let json = response.data;
      json = takeOutDoc(response.data);

      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad booking details");
      }

      resolve(json);
    } catch (e) {
      reject(new Error("error getting bookings"));
    }
  });
};

export const getArrivalsForecastRange = async (params, signal) => {
  const token = await getToken();

  const startDate = moment(new Date(params.start)).format().split("T")[0]
  const endDate = moment(new Date(params.end)).format().split("T")[0]


  const new_url =
    "/api/v1/bookings/bookings/" +
    params.iata +
    "?start=" +
    startDate +
    "&end=" +
    endDate +
    "&limit=" +
    params.limit +
    "&skip=" +
    params.skip +
    "&type=inbound" +
    "&name=" +
    params.search +
    "&carrierCode=" +
    (params.carrierCode != undefined ? params.carrierCode : "") +
    `${params.csv ? '&csv=' + params.csv : ''}` +
    `${params.source ? '&source=' + params.source : ''}` +
    `${params.forecast ? '&forecast=' + params.forecast : ''}`
    ;

  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.get(new_url, {
        signal: signal.signal,
        headers: { "Firebase-UID": token },
      });
      let result = {
        bookings: response.data,
        startDate: startDate,
        endDate: endDate,
      }
      if (params.csv || params.forecast) {
        resolve(result)
      }

      let json = response.data;
      json = takeOutDoc(response.data);

      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad booking details");
      }

      resolve({ bookings: json, startDate: startDate, endDate: endDate });

    } catch (e) {
      reject(new Error("error getting bookings"));
    }
  });
};
export const getBookingDocuments = async (params) => {
  const token = await getToken();

  const new_url =
    "/api/v1/bookings/bookings/" +
    params.iata +
    "?start=" +
    params.start +
    "&end=" +
    params.end +
    "&limit=" +
    params.limit +
    "&skip=" +
    params.skip +
    "&type=" + params.type +
    "&include_docs=true" +
    "&name=" + "&carrierCode=" +
    `${params.csv ? '&csv=' + params.csv : ''}` +
    `${params.source ? '&source=' + params.source : ''}` +
    `${params.forecast ? '&forecast=' + params.forecast : ''}
    `;

  // console.log('new url ', new_url);

  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.get(new_url, {
        headers: { "Firebase-UID": token },
      });

      let json = response.data;

      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad booking details");
      }

      // console.log('json', json)
      resolve(json);
    } catch (e) {
      reject(new Error("error getting bookings"));
    }
  });
};

export const getWeeklyForecast = async (params, signal) => {
  const token = await getToken();
  const daysArr = [0, 1, 2, 3, 4, 5, 6];
  const getUrl = (day) =>
    "/api/v1/bookings/bookings/" +
    params.iata +
    "?start=" +
    add(new Date(params.start), { days: day }).toISOString().split("T")[0] +
    "&end=" +
    add(new Date(params.start), { days: day }).toISOString().split("T")[0] +
    "&limit=" +
    params.limit +
    "&skip=" +
    params.skip +
    "&type=" +
    params.type +
    "&name=" +
    params.search +
    "&carrierCode=" +
    (params.carrierCode != undefined ? params.carrierCode : "") +
    `${params.csv ? "&csv=" + params.csv : ""}` +
    `${params.source ? "&source=" + params.source : ""}` +
    `${params.forecast ? "&forecast=" + params.forecast : ""}`;
  return new Promise(async (resolve, reject) => {
    const dataArr = [];
    // Use Promise.all to send all requests at once and wait for all responses
    Promise.all(
      daysArr.map((day) =>
        axios.get(getUrl(day), {
          signal: signal.signal,
          headers: { "Firebase-UID": token },
        })
      )
    )
      .then((responses) => Promise.all(responses.map((res) => res.data)))
      .then((data) => {
        data.forEach((count, index) => {
          dataArr.push({
            analytics: count,
            day: add(new Date(params.start), { days: daysArr[index] })
              .toISOString()
              .split("T")[0],
          });
        });

        resolve(dataArr);
      })
      .catch((error) => {
        console.log(error, "getWeeklyForecast Error");

        reject(error);
      });
  });
};




export const getDailyBookings = async (params) => {
  const token = await getToken();

  const new_url =
    "/api/v1/bookings/bookings/" +
    params.iata +
    "?start=" +
    params.start +
    "&end=" +
    params.end +
    "&limit=" +
    params.limit +
    "&skip=" +
    params.skip;

  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(new_url, {
        method: "GET",
        headers: { "Firebase-UID": token },
      });

      let json = await response.json();

      if (params.csv) {
        resolve(response.data)
      }

      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad booking details");
      }

      resolve(json);
    } catch (e) {
      reject(new Error("error getting bookings"));
    }
  });
};

export const getUserBookings = async (options) => {
  // this is to check when using this service function to get the
  // info for the qr code page when no one is logged in
  // i.e. which type of auth to use
  let url = "/api/v1/bookings/bookings/id/" + options.booking_id;
  let headers = {};

  // if coming from qr code
  if (options.token) {
    url = url + `?firebase_uid=${options.token}`;
  } else {
    let token = await getToken();
    headers = { "Firebase-UID": token };
  }
  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(url, { method: "GET", headers });
      let json = await response.json();

      if (response.status >= 400 && response.status < 600) {
        if (response.status == 504) {
          throw new Error("Server Error");
        } else if (response.status == 500) {
          throw new Error("Issue with finding booking information");
        } else {
          throw new Error(json.message);
        }
      }
      resolve(json);
    } catch (e) {
      reject(new Error("error getting bookings"));
    }
  });
};

export const getTransactions = (uid) => {
  const url = "/api/v1/marketplace/transactions?userId=" + uid;
  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();
      const response = await fetch(url, {
        method: "GET",
        headers: { "Firebase-UID": token },
      });
      let json = await response.json();
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad transactions details");
      }
      resolve(json);
    } catch (e) {
      reject(new Error("error getting transactions"));
    }
  });
};

// patch booking
export const patchBooking = async (booking) => {
  let headers = {
    accept: "application/json",
    "Content-Type": "application/json",
  };
  let local_url = "/api/v1/bookings/bookings";

  // always a real user token — the old "confirming-booking" bypass is gone
  const token = await getToken();
  // never send a legacy `token` field into the booking doc
  const { token: _legacyToken, ...body } = booking.newBooking || booking;

  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(local_url, {
        method: "PATCH",
        body: JSON.stringify(body),
        headers: {
          "Firebase-UID": token,
          accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      let json = await response.json();
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad booking details");
      }
      resolve(json);
    } catch (e) {
      reject(new Error("Error confirming your booking"));
    }
  });
};
//This function accepts booking object with id, and any property we need to update, not full booking object.
export const updateBooking = async (booking) => {

  let local_url = "/api/v1/bookings/bookings/patchBooking/" + booking.id;

  const token = await getToken();

  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(local_url, {
        method: "PATCH",
        body: JSON.stringify(booking.body),
        headers: {
          "Firebase-UID": token,
          accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      let json = await response.json();
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad booking details");
      }
      resolve(json);
    } catch (e) {
      reject(new Error("Error confirming your booking"));
    }
  });
};

// patch booking
export const patchBookings = async (bookings) => {
  const token = await getToken();

  const errors = [];
  const promises = bookings.map(async (booking) => {
    const local_url = "/api/v1/bookings/bookings";
    const { token: _legacyToken, ...body } = booking.newBooking || booking;

    try {
      const response = await fetch(local_url, {
        method: "PATCH",
        body: JSON.stringify(body),
        headers: {
          "Firebase-UID": token,
          accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      const json = await response.json();

      if (response.status >= 400 && response.status < 600) {
        if (response.status == 403) {
          errors.push('The booking has successfully been requested but only the departure or arrival airport of the flight can confirm the booking.')
        }
        else {
          errors.push("Bad booking details");
        }
        return null;
      }

      return json;
    } catch (error) {
      errors.push("Error confirming your booking");
      return null;
    }
  });

  const responses = await Promise.all(promises);
  const filteredResponses = responses.filter((response) => response !== null);

  if (errors.length > 0) {
    throw new Error(
      `Request failed for one or more bookings: ${errors.join("; ")}`
    );
  }

  return filteredResponses;
};

export const postBookings = async (bookings) => {
  try {
    //console.log('getting token...');
    const token = await getToken();
    //console.log('token got...');

    const promises = bookings.map(async (booking, index) => {

      console.log('waiting for response....');
      const response = await fetch(url, {
        method: "POST",
        body: JSON.stringify(booking),
        headers: {
          "Firebase-UID": token,
          accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      const json = await response.json();
      // console.log('response', json);
      // console.log('response.status', response.status);

      if (response.status >= 400 && response.status < 600) {
        if (response.status === 400) {
          if (json.validationErrors && json.validationErrors.errors?.length) {
            throw new Error(json.validationErrors.errors[0].msg)
          } else {
            throw new Error(
              `${json.message},can not find a relevant flight ${booking.flightDetails.carrierCode}${booking.flightDetails.flightNumber}`
            );
          }

        } else if (response.status === 500) {
          throw new Error(
            "There was an issue connecting with the network resulting in an error. Check your connection or the PRM Server Status."
          );
        } else if (response.status === 409) {
          throw new Error(
            `A booking for this passenger ${booking.name} and flight ${booking.flightDetails.carrierCode}${booking.flightDetails.flightNumber} already exists.`,
          );
        } else {
          throw new Error("Unknown Error,please connect with PRM development team");
        }
      }
      else {
        //console.log('returning json...')
        return json;
      }


    });

    const responses = await Promise.all(promises);
    //console.log('all responded', responses);
    return responses;

  } catch (error) {
    console.error('Error during booking submission:', error);
    throw error
  }
};

// post booking
export const postBooking = async (booking) => {

  console.log('creating booking...');

  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();

      const response = await fetch(url, {
        method: "POST",
        body: JSON.stringify(booking),
        headers: {
          "Firebase-UID": token,
          accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      let json = await response.json();
      console.log('response', json)

      if (response.status >= 400 && response.status < 600) {
        if (response.status == 400) {
          throw new Error(
            "There was an issue with the flight details submitted as we cannot find a relevant flight with the given information."
          );
        } else if (response.status == 500) {
          throw new Error(
            "There was an issue with the network resulting in an error"
          );
        } else if (response.status == 409) {
          throw new Error(
            "A booking  for this name and flight already exists."
          );
        } else {
          throw new Error("Unkown Error");
        }
      }
      resolve(json);
    } catch (error) {
      reject(new Error(error.message));
    }
  });
};

// delete booking
export const deleteBooking = async (booking) => {
  let id = booking._id || booking;

  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();
      const response = await fetch(`${url}/${id}`, {
        method: "DELETE",
        headers: { "Firebase-UID": token },
      });
      let json = await response.json();

      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad request details");
      }

      resolve(json);
    } catch (e) {
      reject(new Error("Error deleting the booking"));
    }
  });

};

// delete booking list
export const deleteBookings = async (bookingIds) => {

  const token = await getToken();

  const promises = bookingIds.map(async (id) => {

    const response = await fetch(`${url}/${id}`, {
      method: "DELETE",
      headers: { "Firebase-UID": token },
    });

    let json = await response.json();

    if (response.status >= 400 && response.status < 600) {
      throw new Error("Bad request details");
    }

    return json;
  });

  return Promise.all(promises);
};

// get requests
export const getRequests = async (params) => {
  const url =
    "/api/v1/bookings/bookings/" +
    params.iata +
    "/confirmTable/?type=" +
    params.type +
    (params.csv ? "&csv=true" : "") +
    (params.confirmed ? "&confirmed=true" : "") +
    "&startDate=" +
    (params.startDate || "") +
    "&endDate=" +
    (params.endDate || "") +
    "&skip=" +
    (params.skip || 0) +
    "&limit=" +
    (params.limit || 50)

  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();

      const response = await fetch(url, {
        method: "GET",
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          "Firebase-UID": token,
        },
      });

      let json = await response.json();
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad booking details");
      }

      resolve(json);
    } catch (e) {
      reject(new Error("Error confirming your booking"));
    }
  });
};

export const getAirlineRequests = async (params) => {
  const url =
    "/api/v1/bookings/bookings/" +
    params.iata +
    "/confirmTable/?airline=" + (params.airline || "true") + "&confirmed=" +
    params.confirmed +
    "&startDate=" + (params.startDate || "") +
    "&endDate=" + (params.endDate || "") +
    "&csv=" + (params.csv || "") +
    "&airport=" + (params.airport || "") +
    "&limit=" + (params.limit || 50) +
    "&skip=" + (params.skip || 0)
    ;

  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();

      const response = await fetch(url, {
        method: "GET",
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          "Firebase-UID": token,
        },
      });

      let json = await response.json();
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad booking details");
      }

      resolve(json);
    } catch (e) {
      reject(new Error("Error confirming your booking"));
    }
  });
};

// get bookings history
export const getBookingsHistory = async () => {
  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();
      const response = await fetch(url, {
        method: "GET",
        headers: { "Firebase-UID": token },
      });

      let json = await response.json();

      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad booking details");
      }
      resolve(json);
    } catch (e) {
      reject(new Error("error getting bookings"));
    }
  });
};

// get all bookings history
export const getAllBookingHistory = async (date) => {
  // const url = "/api/v1/bookings/bookings";
  const local_url =
    url +
    "/DUB?start=" +
    date +
    "&end=" +
    date +
    "&limit=1000&skip=0&type=all&name=&carrierCode=&source=P";

  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();
      const response = await fetch(local_url, {
        method: "GET",
        headers: { "Firebase-UID": token },
      });

      let json = await response.json();

      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad booking details");
      }

      resolve(json);
    } catch (e) {
      reject(new Error("error getting bookings"));
    }
  });
};

// get booking breakdown
export const getBookingBreakdownInbound = async (params) => {
  let local_url = "";
  if (params.airline) {
    local_url =
      "/api/v1/bookings/bookingAnalytics/" +
      params.iata +
      "/counts?date=" +
      params.date +
      "&type=" +
      params.type +
      "&range=month&" +
      "byType=none&" +
      "airline=" +
      params.airline +
      "&endDate=&" +
      "byHour=&" +
      "source=" +
      params.source +
      "&byFlight=&" +
      "forecast=&" +
      "breakDownByRequest=" +
      params.requestType;
    // false means the request was not sent to airport
    // true means request sent to airport
  } else {
    local_url =
      "/api/v1/bookings/bookingAnalytics/" +
      params.iata +
      "/counts?date=" +
      params.date +
      "&type=" +
      params.type +
      "&range=month&" +
      "byType=none&" +
      "airline=" +
      "&endDate=&" +
      "byHour=&" +
      "source=" +
      params.source +
      "&byFlight=&" +
      "forecast=&" +
      "breakDownByRequest=" +
      params.requestType;
    // false means the request was not sent to airport
    // true means request sent to airport
  }

  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();
      const response = await fetch(local_url, {
        method: "GET",
        headers: { "Firebase-UID": token },
      });

      let json = await response.json();

      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad booking breakdown information");
      }
      resolve(json);
    } catch (e) {
      reject(new Error("error getting bookings"));
    }
  });
};

// confirm requests for the caller's airport/airline.
// Responds { confirmed: string[], skipped: [{ id, reason }] } — bookings outside the
// caller's airport/airline are skipped server-side. Older servers return a string.
export const patchRequests = async (params) => {
  const new_url =
    "api/v1/bookings/bookings/confirmBookings?type=" + params.type;

  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();

      const response = await fetch(new_url, {
        method: "POST",
        body: JSON.stringify(params.requests),
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          "Firebase-UID": token,
        },
      });
      let json = await response.json();
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad booking details");
      }
      resolve(json);
    } catch (e) {
      reject(new Error("Error confirming your booking"));
    }
  });
};

export const getConfirmedRequests = async (params) => {
  let new_url = "";
  console.log(params, "params...")
  if (params.type == "airline") {
    new_url =
      "api/v1/bookings/bookings/" +
      params.iata +
      "/confirmTable/?airline=" + (params.airline || "true") + "&confirmed=true" +
      "&startDate=" +
      (params.startDate || "") +
      "&endDate=" +
      (params.endDate || "")
    "&limit=" +
      (params.limit || 50)
    "&skip=" +
      (params.skip || 0);
  } else {
    new_url =
      "api/v1/bookings/bookings/" +
      params.iata +
      "/confirmTable?type=" +
      params.type +
      "&confirmed=true" +
      "&startDate=" +
      (params.startDate || "") +
      "&endDate=" +
      (params.endDate || "") +
      "&limit=" +
      (params.limit || 50)
    "&skip=" +
      (params.skip || 0);
  }

  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();

      const response = await fetch(new_url, {
        method: "GET",
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          "Firebase-UID": token,
        },
      });
      let json = await response.json();
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad booking details");
      }
      resolve(json);
    } catch (e) {
      reject(new Error("Error confirming your booking"));
    }
  });
};

export const getPrenotifiedBookings = async (params) => {
  const token = await getToken();

  const new_url =
    "/api/v1/bookings/bookingAnalytics/" +
    params.iata +
    "/counts" +
    "?date=" +
    params.startDate +
    "&endDate=" +
    params.endDate +
    "&type=all&airline=&endDate=&byHour&source=&byFlight=&forecast=&destinationAirport=" +
    "&pre_advised=" +
    params.preAdvised +
    "&dueTime=true";

  // console.log('prenotified bookings url', new_url);

  return new Promise(async (resolve, reject) => {
    try {

      const response = await fetch(new_url, {
        method: "GET",
        headers: { "Firebase-UID": token },
      });

      let json = await response.json();

      //console.log('pre notified bookings response: ', json)

      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad booking details");
      }

      resolve(json);
    } catch (e) {
      reject(new Error("error getting bookings"));
    }
  });
};

// TEXTBOOK
export const getReport = async (params) => {
  const token = await getToken();

  const new_url =
    "/api/v1/bookings/bookings/report/" +
    params.iata +
    "?start=" +
    params.flightDate +
    "&end=" +
    params.flightDate +
    "&skip=0" +
    "&limit=100000" +
    "&carrierCode=" +
    params.carrierCode +
    "&flightNumber=" +
    params.flightNumber;

  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(new_url, {
        method: "GET",
        headers: { "Firebase-UID": token },
        responseType: "blob",
      });
      let json = await response.json();
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad booking details");
      }

      resolve(json);
    } catch (e) {
      reject(new Error("error getting bookings"));
    }
  });
};

export const getExcelReport = async (params) => {
  const token = await getToken();

  const new_url =
    "/api/v1/bookings/bookings/report/" +
    params.iata +
    "?start=" +
    params.flightDate +
    "&end=" +
    params.flightDate +
    "&skip=0" +
    "&limit=100000" +
    (params.carrierCode ? "&carrierCode=" + params.carrierCode : "") +
    (params.flightNumber ? "&flightNumber=" + params.flightNumber : "");

  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(new_url, {
        method: "GET",
        headers: { "Firebase-UID": token },
        responseType: "blob", // Important: Specify the response type as 'blob'
      });
      let body = await response.body;
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad booking details");
      }

      resolve(body);
    } catch (e) {
      console.log("temp error", e);
      reject(new Error("error getting file"));
    }
  });
};

export const exportForecast = async (params) => {
  let data = params.data;
  function convertToCSV(arr) {
    let headers = ["flight", "average", "actual", "date", "id"];
    const headerRow = headers.join(",");

    // process each flight forecast
    const rows = arr
      .map((flightForecast) => {
        let average = parseInt(flightForecast.average).toFixed(1);

        // map the flight forecast values to the corresponding header
        return headers
          .map((header) => {
            switch (header) {
              case "flight":
                return flightForecast.flight;
              case "average":
                return average;
              case "actual":
                return flightForecast.actual;
              case "date":
                return `${flightForecast.formattedTime} ${flightForecast.time}`;
              case "id":
                return flightForecast.id;
              default:
                return "";
            }
          })
          .join(",");
      })
      .join("\n");

    return headerRow + "\n" + rows;
  }

  function downloadCSV(csvString, filename = "export.csv") {
    // Create a Blob from the CSV String
    const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });

    // Create a link to download it
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  let csvString = convertToCSV(data);

  const startDate = moment(new Date(params.date[0])).format().split("T")[0]
  const endDate = moment(new Date(params.date[1])).format().split("T")[0]
  let csvFileName =
    `${params.type}-forecast-table-- from_${startDate} to_${endDate} .csv`;
  downloadCSV(csvString, csvFileName);
};
// get bookings duetimes
export const getBookingsDueTimes = async (params) => {
  const url =
    "/api/v1/bookings/bookingAnalytics/" +
    params.iata +
    "/counts/dueTime?date=" +
    "2021-04-16" +
    "&endDate=" +
    "2025-04-16";

  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();

      const response = await fetch(url, {
        method: "GET",
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          "Firebase-UID": token,
        },
      });
      let json = await response.json();
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad booking details");
      }

      resolve(json);
    } catch (e) {
      reject(new Error("Error confirming your booking"));
    }
  });
};

export const getBookingsDueTimesBetweenAirports = async (params) => {
  const url =
    "/api/v1/bookings/bookingAnalytics/" +
    params.iata +
    "/counts/getDueTimesBetweenAirports/" +
    params.departureAirportIATA +
    "/" +
    params.arrivalAirportIATA +
    "?date=" +
    (params.date || "") +
    "&endDate=" +
    (params.endDate || "");

  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();

      const response = await fetch(url, {
        method: "GET",
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          "Firebase-UID": token,
        },
      });
      let json = await response.json();
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad booking details");
      }

      resolve(json);
    } catch (e) {
      reject(new Error("Error confirming your booking"));
    }
  });
};

export const getNoShowCount = async (params) => {
  console.log('getting no show count...', params);

  const token = await getToken();

  const url =
    "/api/v1/bookings/bookingAnalytics/" +
    params.iata +
    "/counts?date=" +
    params.date +
    "&type=outbound&range=&byType=none&airline=&endDate=" +
    params.date +
    "&byHour=&source=&byFlight=&noshows=true";

  console.log('get no show count url : ', url);

  return new Promise(async (resolve, reject) => {
    try {
      const json = await axios.get(url, {
        headers: { "Firebase-UID": token },
      });

      if (json.status >= 400 && json.status < 600) {
        throw new Error("Bad booking details");
      }

      console.log('response from no show count: ', json.data)
      resolve(json.data);
    } catch (e) {
      reject(new Error("error getting bookings"));
    }
  });
}

export const getSitaMessages = async (params) => {
  const token = await getToken();

  const url = `/api/v1/bookings/sita/messages/${params.iata}?start=${params.start}&end=${params.end}&limit=${params.limit}&skip=${params.skip}&type=${params.type}&search=${params.searchValue}&airport=${params.airport}`;


  return new Promise(async (resolve, reject) => {
    try {
      const json = await axios.get(url, {
        headers: { "Firebase-UID": token },
      });

      if (json.status >= 400 && json.status < 600) {
        throw new Error("Bad details");
      }
      resolve(json.data);
    } catch (e) {
      reject(new Error("error getting sita messages"));
    }
  });
}
